import customerUsers from '@/api/security/customer-users'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from "lodash";

export const state = {
  ...baseState,
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  }
}
export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
        }
      },
      attrubutes
    )
    return customerUsers.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return customerUsers.store(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await customerUsers.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return customerUsers.destroy(id)
  },
  passwordReset(context, { id, data }) {
    return customerUsers.passwordReset(id, data)
  },
  unlock(context, data) {
    return customerUsers.unlock(data)
  },
  changePassword(context, data) {
    return customerUsers.changePassword(data)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await customerUsers.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
